import { useState } from 'react'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shad/ui/Select.tsx'
import { useSelector } from 'react-redux'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice.ts'
import { useStudentPurses } from '@/app/pages/providers/api/usePaymentProviders.tsx'
import { selectFamilyApplication } from '@/storage/applications/familyApplicationSlice.ts'
import { currencyFormatter } from '../../utilities'

const StudentBalances = () => {
  const application = useSelector(selectFamilyApplication)
  const programId = useSelector(selectProgramID)

  const { data: purses } = useStudentPurses(
    { program_id: programId, application_id: application?.application_id },
    { enabled: !!application?.application_id && !!programId }
  )

  const [selectedStudentId, setSelectedStudentId] = useState<number | null>(
    null
  )

  return (
    <div className="hidden lg:block w-56">
      <Select
        value={selectedStudentId?.toString() || ''}
        onValueChange={(value) => setSelectedStudentId(Number(value))}
      >
        <SelectTrigger className="w-full max-w-56">
          <SelectValue className="w-full" placeholder="Student Purses" />
        </SelectTrigger>

        <SelectContent>
          {purses?.map((purse) => (
            <SelectItem className="" key={purse.id} value={purse.id.toString()}>
              <div className="min-w-0">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-gray-800 font-medium text-sm truncate">
                    {purse.student_name}
                  </span>
                  <span className="text-green-600 font-medium flex-shrink-0">
                    {currencyFormatter.format(purse.balance_available)}
                  </span>
                </div>
                <div className="text-gray-600 text-xs truncate">
                  {purse.name}
                </div>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
export default StudentBalances
